module.exports = __webpack_public_path__ + "static/media/allie18.9b8b3414.jpg";